import React, { createContext, useEffect, useState } from "react";
import { getAuthData, saveAuthData, removeAuthData } from "../../Utils/authUtils";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  

  // 🔹 Check if user exists in IndexedDB on load
  useEffect(() => {
    async function checkPersistentLogin() {
      const storedUser = await getAuthData("user");
      if (storedUser) {
        setUser(storedUser);
      } else {
        // window.location.href = '/'; // Redirect to login if no user found
      }
    }
    checkPersistentLogin();
  }, []);

  // 🔹 Login function (stores data in IndexedDB)
  const afterLogin = async (userData) => {
    setUser(userData);
    await saveAuthData("user", userData);
  };

  // 🔹 Logout function (removes data from IndexedDB)
  const afterLogout = async () => {
    setUser(null);
    await removeAuthData("user");
    window.location.href = '/';
  };

  return (
    <AuthContext.Provider value={{ user, afterLogin, afterLogout }}>
      {children}
    </AuthContext.Provider>
  );
};
